/**
 * Generated by orval v8.20.0 🍺
 * Do not edit manually.
 * Cloud Drive
 * In the documentation API requests will be sent from currently logged in user so you do not need to provide a bearer token manually. <br><br> When calling API from outside the documentation, you will need to provide an access token for all requests in authorization header: `Authorization: Bearer <Token>` <br> You can create a new access token in your account settings page.
 * OpenAPI spec version: 1.0.0
 */
import type {GetBootstrapData200} from './schemas/get-bootstrap-data200';

import type {GetSiteAlerts200} from './schemas/get-site-alerts200';

import {orvalApiFetch} from '../../../common/foundation/resources/client/http/query-client';

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];

/**
 * @summary Generate sitemap
 */
export const generateSitemap = (
  options?: SecondParameter<typeof orvalApiFetch<void>>,
) => {
  return orvalApiFetch<void>(
    {url: `/sitemap/generate`, method: 'POST'},
    options,
  );
};
/**
 * @summary Get site alerts
 */
export const getSiteAlerts = (
  options?: SecondParameter<typeof orvalApiFetch<GetSiteAlerts200>>,
) => {
  return orvalApiFetch<GetSiteAlerts200>(
    {url: `/admin/site-alerts`, method: 'GET'},
    options,
  );
};
/**
 * @summary Flush the cache
 */
export const flushCache = (
  options?: SecondParameter<typeof orvalApiFetch<void>>,
) => {
  return orvalApiFetch<void>({url: `/cache/flush`, method: 'POST'}, options);
};
/**
 * @summary Get data needed to bootstrap the app
 */
export const getBootstrapData = (
  options?: SecondParameter<typeof orvalApiFetch<GetBootstrapData200>>,
) => {
  return orvalApiFetch<GetBootstrapData200>(
    {url: `/bootstrap-data`, method: 'GET'},
    options,
  );
};
/**
 * @summary Get data needed to bootstrap the mobile app
 */
export const getMobileBootstrapData = (
  options?: SecondParameter<typeof orvalApiFetch<unknown>>,
) => {
  return orvalApiFetch<unknown>(
    {url: `/remote-config/mobile`, method: 'GET'},
    options,
  );
};
/**
 * @summary Perform app update
 */
export const runUpdate = (
  options?: SecondParameter<typeof orvalApiFetch<string>>,
) => {
  return orvalApiFetch<string>({url: `/update`, method: 'POST'}, options);
};
export type GenerateSitemapResult = NonNullable<
  Awaited<ReturnType<typeof generateSitemap>>
>;
export type GetSiteAlertsResult = NonNullable<
  Awaited<ReturnType<typeof getSiteAlerts>>
>;
export type FlushCacheResult = NonNullable<
  Awaited<ReturnType<typeof flushCache>>
>;
export type GetBootstrapDataResult = NonNullable<
  Awaited<ReturnType<typeof getBootstrapData>>
>;
export type GetMobileBootstrapDataResult = NonNullable<
  Awaited<ReturnType<typeof getMobileBootstrapData>>
>;
export type RunUpdateResult = NonNullable<
  Awaited<ReturnType<typeof runUpdate>>
>;
